import Vue from 'vue'

const globalMixin = {
    filters: {
        zeroPadding(input) {
            return ('00' + input).slice(-2)
        },
        // format duration seconds to HHMM24
        formatHHMM24(seconds) {
            if (!seconds) {
                return '00:00'
            } else if (seconds <= 0) {
                return '00:00'
            } else if (seconds > 24 * 60 * 60 * 1000) {
                return '24:00'
            } else {
                let n = (seconds + 1000) / 1000
                let H = Math.floor(n / 3600)
                let HH = ('00' + H).slice(-2)
                let M = Math.floor(((n % (24 * 60 * 60)) % (60 * 60)) / 60)
                let MM = ('00' + M).slice(-2)
                return HH + ':' + MM
            }
        },
        // format duration seconds to HHMMSS
        formatHHMMSS(seconds) {
            const oneSecond = 1000
            const oneMinute = oneSecond * 60
            const oneHour = oneMinute * 60

            const H = Math.floor(seconds / oneHour)
            const HH = H <= 9 ? ('00' + H).slice(-2) : H
            const M = Math.floor((seconds % oneHour) / oneMinute)
            const MM = ('00' + M).slice(-2)
            const S = Math.floor((seconds % oneMinute) / oneSecond)
            const SS = ('00' + S).slice(-2)

            return `${HH}:${MM}:${SS}`
        },
        // seconds to [HH]:MM
        formatHHHMM(seconds) {
            if (seconds <= 0 || !seconds) {
                return '-'
            } else {
                let n = (seconds + 7000) / 1000
                let H = Math.floor(n / 3600)
                let HH = H < 10 ? ('00' + H).slice(-2) : H
                let M = Math.floor(((n % (24 * 60 * 60)) % (60 * 60)) / 60)
                let MM = ('00' + M).slice(-2)
                return HH + ':' + MM
            }
        },
        formatD(seconds) {
            const oneSecond = 1000
            const oneMinute = oneSecond * 60
            const oneHour = oneMinute * 60
            const oneDay = oneHour * 24
            return Math.ceil(seconds / oneDay)
        },
        // start = "2022-06-23 16:12:06"
        // output seconds
        stringToSeconds(start) {
            return new Date(
                start.toString().replace(/-/g, '/').replace(/T/g, ' ')
            ).getTime()
        },
        startToNowSeconds(start) {
            const startSeconds = new Date(
                start.toString().replace(/-/g, '/').replace(/T/g, ' ')
            ).getTime()
            const nowSeconds = new Date().getTime()
            return nowSeconds - startSeconds
        },
        // start = "2022-06-23 16:12:06"
        // output "6/23 16:12"
        displayStartString(start) {
            if (!start) return
            const time = start.slice(11, 16)
            const startDate = new Date(
                start.toString().replace(/-/g, '/').replace(/T/g, ' ')
            )
            const today = new Date()
            today.setHours(0, 0, 0)
            const diff = today.getTime() - startDate.getTime()
            if (diff > 0) {
                const M = startDate.getMonth() + 1
                const D = startDate.getDate()
                return `${M}/${D} ${time}`
            } else {
                return time
            }
        },
    },
}

Vue.mixin(globalMixin)

export default globalMixin
